import { Predicates } from "../../../libraries/predicates/predicates";
import { CreateArtworkCollectionState } from "../state/collection/create/data";

export const formatCollectionOptions = (item: CreateArtworkCollectionState| null) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
      value: item,
      label: `${item.code} - ${item.name} ${item.year}`,
    }
    : null;
}

export const getCollections = (collections: CreateArtworkCollectionState[]) =>
  collections?.map(formatCollectionOptions).filter(Predicates.isNotNullAndNotUndefined)
